import { Box, Text, chakra } from "@chakra-ui/react";

const FormContainer = chakra(Box, {
  baseStyle: {
    width: { base: "full", md: "100%" },
    display: "flex",
    flexDirection: "column",
    paddingTop: "12px",
  },
});

const AllSetTopHeading = chakra(Text, {
  baseStyle: {
    display: "flex",
    // marginTop: { base: "24px" },
    textAlign: "center",
    justifyContent: "center",
    alignContent: "center",
    color: "gray.lightGray",
  },
});

const StyledDoubledText = chakra(Text, {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "500",
    color: "gray.neutral",
    fontSize: "32px",
    gap: "10px",
  },
});
const StyledDoubledEmailText = chakra(Text, {
  baseStyle: {
    display: "flex",
    alignItems: "start",
    fontWeight: "500",
    color: "gray.neutral",
    fontSize: "16px",
    gap: "10px",
    justifyContent: "ce",
  },
});

const AllSetHeading = chakra(Text, {
  baseStyle: {
    fontWeight: "500",
    fontSize: { base: "24px", md: "32px" },
    marginTop: { base: "18px" },
    textAlign: "center",
    color: "gray.neutral",
  },
});
const AllSetSubHeading = chakra(Text, {
  baseStyle: {
    fontWeight: "500",
    fontSize: { base: "12px", md: "32px" },
    alignItems: "flex-start",
    color: "primary.neutral",
  },
});

const ResetPasswordDescriptionHeading = chakra(Text, {
  baseStyle: {
    fontWeight: "400",
    fontSize: { base: "12px", md: "16px" },
    textAlign: "center",
    color: "primary.grayText",
  },
});

const ResetPasswordRequirements = chakra(Text, {
  baseStyle: {
    fontWeight: "400",
    fontSize: { base: "12px", md: "14px" },
    display: "flex",
    direction: "column",
    alignItems: "flex-start",
    color: "gray.500",
    justifyItems: "start",
    justifyContent: "start",
  },
});

const ForgotPasswordForm = chakra("form", {
  baseStyle: {
    width: "100%",
  },
});

export {
  FormContainer,
  AllSetTopHeading,
  StyledDoubledText,
  AllSetHeading,
  AllSetSubHeading,
  ResetPasswordDescriptionHeading,
  ForgotPasswordForm,
  ResetPasswordRequirements,
  StyledDoubledEmailText,
};
